<template>
  <el-dialog title="编辑导师信息" :visible="true" width="40%" :close-on-press-escape="false"
    :close-on-click-modal="false" @close="$parent.$parent.teacherAvatarFormVisible = false">
    <el-form ref="form" :model="teacher">
      <el-row>
        <el-col :span="24">
          <el-form-item label="导师头像">
            <el-upload class="avatar-uploader" :action="uploadUrl" drag :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="teacher.avatar" :src="teacher.avatar" class="avatar" />
              <div v-else>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </div>
            </el-upload>
            <div>推荐尺寸120*120</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="姓名学校履历1">
            <el-input v-model="teacher.academic_resume_1" type="textarea" :rows="2" placeholder="请输入姓名学校履历1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="学术履历2">
            <el-input v-model="teacher.academic_resume_2" type="textarea" :rows="2" placeholder="请输入学术履历2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="学术履历3">
            <el-input v-model="teacher.academic_resume_3" type="textarea" :rows="2" placeholder="请输入学术履历3"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="$parent.$parent.teacherAvatarFormVisible = false">取消</el-button>
      <el-button type="primary" @click="commit" :disabled="commitable">
        确认
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from '../axios'
export default {
  name: 'teacherAvatarForm',
  data() {
    return {
      uploadUrl: `${axios.defaults.baseURL}/upload/`,
      teacher: {
        id: '',
        name: '',
        avatar: '',
        academic_resume_1: '',
        academic_resume_2: '',
        academic_resume_3: ''
      },
      commitable: false
    }
  },
  methods: {
    commit() {
      this.commitable = true
      axios.put('/DBS/teacher/avatar', {
        id: this.teacher.id,
        avatar: this.teacher.avatar,
        academic_resume_1: this.teacher.academic_resume_1,
        academic_resume_2: this.teacher.academic_resume_2,
        academic_resume_3: this.teacher.academic_resume_3
      }).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$parent.$parent.teacherAvatarFormVisible = false
          this.$parent.$parent.search()
        }
      })
    },
    handleAvatarSuccess(res) {
      this.teacher.avatar = res.url
      this.$forceUpdate()
    },
    beforeAvatarUpload(file) {
      const isImage = ['image/jpeg', 'image/png'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传头像图片只能是 JPG/JPEG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    }
  }
}
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
